import { User } from "@/types";
import * as LDClient from "launchdarkly-js-client-sdk";

class FeatureConfigs {
  ldclient!: LDClient.LDClient;

  private getVariation(featureKey: string, defaultValue?: any): any {
    return this.ldclient.variation(featureKey, defaultValue);
  }

  public async init(user: User, uid: string): Promise<FeatureConfigs> {
    const userContext: LDClient.LDUser = {
      key: uid,
      email: user.email,
      name: user.email.split("@")[0],
      custom: {
        groups: user.groups,
        roles: user.roles
      }
    };
    const options: LDClient.LDOptions = {
      bootstrap: "localStorage"
    };

    this.ldclient = LDClient.initialize(
      process.env.VUE_APP_LAUCHDARKLY_CLIENT_ID,
      userContext,
      options
    );

    await this.ldclient.waitUntilReady();
    return this;
  }

  public onChange(callback: (...args: any[]) => void) {
    return this.ldclient.on("change", callback);
  }

  public getAutoAccept(defaultValue = false) {
    return this.getVariation("auto_accept", defaultValue);
  }

  public getAllFlags(): LDClient.LDFlagSet {
    return this.ldclient.allFlags();
  }

  public getGroups(groups: string[]) {
    return groups.map(group => this.getVariation(group, {}));
  }

  public getGroup(group: string) {
    return this.getVariation(group, {});
  }

  public getGroupTypes(): Array<string> {
    return this.getVariation("groups", []);
  }

  public getAgentOfRecord(): Array<string> {
    return this.getVariation("agent_of_record", []);
  }
}

export default new FeatureConfigs();
